module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-ko-KR.52190033.jpg";